import { api } from "@/api";
import type { NotificationItem, NotificationsResponse, TaskReminderItem } from "@/types/domain";

// The REST endpoint returns camelCase JSON; map to PascalCase to match the
// shared localStorage cache format that legacy notify.js reads/writes.
const mapNotification = (n: any): NotificationItem => ({
  Id: n.id,
  Subject: n.subject,
  Body: n.body,
  SendDate: n.sendDate,
  Source: n.source ? { SourceType: n.source.sourceType, SourceID: n.source.sourceId } : undefined,
  Owner: n.owner ? { Name: n.owner.name } : undefined,
});

const mapTask = (t: any): TaskReminderItem => ({
  ID: t.id,
  Subject: t.subject,
  DueDate: t.dueDate,
  Priority: t.priority,
  Company: t.company ? { CompanyName: t.company.companyName } : undefined,
  RecMaster: t.recMaster,
  RecurrenceIndex: t.recurrenceIndex,
});

export const getNotifications = async (): Promise<NotificationsResponse | null> => {
  const res = await api.get<any>("/notifications");
  if (!res.data) return null;
  return {
    notifications: (res.data.notifications ?? []).map(mapNotification),
    tasks: (res.data.tasks ?? []).map(mapTask),
  };
};

export const dismissTask = async (
  taskId: string,
  recurrenceMaster: string | null,
  recurrenceIndex: number | null
): Promise<void> => {
  await api.post("/notifications/tasks/dismiss", {
    taskId,
    recurrenceMaster,
    recurrenceIndex,
  });
};

export const removeNotification = async (id: string): Promise<void> => {
  await api.delete(`/notifications/${encodeURIComponent(id)}`);
};
